import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useTrashList(isTemplate) {
  const refItemsListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'name', label: i18nT(`Name`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'type', label: i18nT(`Type`), sortable: true },
    { key: 'deleted_by', label: i18nT(`Deleted by`), sortable: true },
    { key: 'deleted_on', label: i18nT(`Deleted on`), sortable: true },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ];

  const perPage = ref(10);
  const totalItems = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const itemType = ref({value: -1, text: i18nT('All types')});
  const items = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refItemsListTable.value
      ? refItemsListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    };
  });

  const refetchData = () => {
    refItemsListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      itemType,
      isSortDirDesc,
      sortBy,
    ],
    () => {
      refetchData();
    }
  );

  const fetchItems = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value
    };

    if (isTemplate) {
      params.templates = 1;
    }

    if (itemType.value.value != -1) {
      params['filters[type]'] = itemType.value.value;
    }

    axios
      .get(`trash`, {
        params,
      })
      .then(({ data }) => {
        items.value = data.data.trash
        callback(data.data.trash);
        totalItems.value = data.data.pagination.records_count;
      });
  };

  return {
    fetchItems,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refItemsListTable,
    totalItems,
    itemType,
    items,
    refetchData,
  };
}
